module.exports = __webpack_public_path__ + "img/mountain.0813a47f.png";